import {
  IFormUtils,
  TFormInit,
  tg,
  TUpdaterResult,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../infrastructure/providers/abstract/IApiProvider';
import { ClientContext } from '../../context/IContextService';
import FormApi from '../api/FormApi';
import { isPredefinedForm } from '../typeguards';
import { FormConfigFields, FormSource } from '../view-model/FormSource';

export const initForm = async (
  ctx: ClientContext,
  args: TActionArgsValues,
  source: FormSource,
  init: TFormInit<any> | undefined,
  formApi: FormApi,
  utils: IFormUtils
): Promise<TUpdaterResult | undefined> => {
  if (!isPredefinedForm(source)) {
    const storedValues = Object.entries<FormConfigFields>(
      source.formConfig
    ).reduce(
      (result, [key, { value }]) =>
        tg.isSomething(value) ? { ...result, [key]: value } : result,
      {}
    );
    if (init !== undefined) {
      return init(
        formApi as any,
        ctx.toClientApiContext(),
        source.editMode,
        args,
        'action' in source ? source.action : undefined,
        utils,
        storedValues
      );
    }
  }

  throw new Error('Unsupported form type');
};
